import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
    Box,
    Container,
    Typography,
    CircularProgress,
    Paper,
    useTheme
} from "@mui/material";
import API from "../api/axiosInstance";

const ReportViewer: React.FC = () => {
    const { reportId } = useParams();
    const [report, setReport] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();

    useEffect(() => {
        fetchReport();
    }, [reportId]);

    const fetchReport = async () => {
        try {
            const response = await API.get(`/reports/run/${reportId}`);
            setReport(response.data);
        } catch (error) {
            console.error("Error running report:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: theme.palette.background.default,
                color: theme.palette.text.primary,
                py: 4,
            }}
        >
            <Container maxWidth="md">
                <Typography variant="h5" gutterBottom>
                    Report Results
                </Typography>

                {loading ? (
                    <Box display="flex" justifyContent="center" mt={4}>
                        <CircularProgress />
                    </Box>
                ) : report ? (
                    <Paper
                        elevation={3}
                        sx={{
                            p: 3,
                            backgroundColor: theme.palette.background.paper,
                            overflowX: "auto",
                            whiteSpace: "pre-wrap",
                            maxHeight: 600,
                        }}
                    >
                        <Typography
                            component="pre"
                            sx={{
                                fontFamily: "monospace",
                                fontSize: "0.9rem",
                                whiteSpace: "pre-wrap",
                                wordWrap: "break-word",
                            }}
                        >
                            {JSON.stringify(report, null, 2)}
                        </Typography>
                    </Paper>
                ) : (
                    <Typography variant="body1" color="error">
                        Failed to load report.
                    </Typography>
                )}
            </Container>
        </Box>
    );
};

export default ReportViewer;
